import { Injectable } from "@nestjs/common";
import { Repository } from "typeorm";
import { InjectRepository } from "@nestjs/typeorm";
import { EmployeeEntity } from "./employee.entity";

@Injectable()
export class EmployeeRepo extends Repository<EmployeeEntity> {
  constructor(
    @InjectRepository(EmployeeEntity)
    private repo: Repository<EmployeeEntity>
  ) {
    super(repo.target, repo.manager, repo.queryRunner);
  }
}